import { render, staticRenderFns } from "./StitchingForm.vue?vue&type=template&id=b828de68&scoped=true"
import script from "./StitchingForm.vue?vue&type=script&lang=js"
export * from "./StitchingForm.vue?vue&type=script&lang=js"
import style0 from "./StitchingForm.vue?vue&type=style&index=0&id=b828de68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b828de68",
  null
  
)

export default component.exports